import { render, staticRenderFns } from "./DressTable.vue?vue&type=template&id=5d0c2d2d"
import script from "./DressTable.vue?vue&type=script&lang=js"
export * from "./DressTable.vue?vue&type=script&lang=js"
import style0 from "./DressTable.vue?vue&type=style&index=0&id=5d0c2d2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports